import React from "react"; 
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import IndexCustom1 from "./pages/IndexCustom";
import { ThemeProvider } from "./components/ThemeContext";
import '@fontsource-variable/inter/index.css';

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <IndexCustom1 />
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);